import { redirect } from 'react-router-dom';
import authLoader from './authLoader';

const maintenanceLoader = async () => {
	const { user } = await authLoader();
	if (!user.permissions.isSystemAdmin && !user.permissions.isMaintenance) {
		throw redirect('/');
	}
	return user;
};

export default maintenanceLoader;
